module.exports = __webpack_public_path__ + "img/1_005.9ad9090b.jpg";